import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import AuthentificationService from "./services/authentification";

const GREEN = "#2fb344";

const styles = {
  page: { minHeight: "100vh", display: "flex", background: "#fff" },
  brandPanel: {
    flex: "1 1 50%",
    background: "#fff",
    borderRight: `6px solid ${GREEN}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "48px",
  },
  formPanel: {
    flex: "1 1 50%",
    background: "#0a0f12",
    color: "#e9ecef",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "32px 16px",
  },
  card: { width: "100%", maxWidth: 420 },
  input: {
    height: 46,
    borderRight: 0,
    background: "#151c21",
    borderColor: "#2a343b",
    color: "#fff",
  },
  inputIcon: {
    background: "#151c21",
    borderColor: "#2a343b",
    borderLeft: 0,
    color: "#9aa5ab",
    cursor: "pointer",
  },
  submit: {
    height: 48,
    background: GREEN,
    borderColor: GREEN,
    fontWeight: 600,
    letterSpacing: 0.3,
  },
};

const Login = () => {
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [userName, setUserName] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mustChange, setMustChange] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newRePassword, setNewRePassword] = useState("");
  const [changeError, setChangeError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("accessIsDenied") === "denied") {
      setOpenInfoAlert(true);
    }
  }, []);

  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenInfoAlert(false);
  };

  const onLoginHandler = (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setOpenErrorAlert(false);
    AuthentificationService.login(userName.trim(), userPassword)
      .then((response) => {
        if (response.data["token"] && response.data["token"].mustChangePassword) {
          setMustChange(true);
          setLoading(false);
          return;
        }
        if (response.data["token"]) {
          localStorage.setItem("user", JSON.stringify(response.data));
          localStorage.setItem(
            "status",
            JSON.stringify(response.data.token.nameRole)
          );
          localStorage.setItem("accessIsDenied", "connected");
          window.location.href = "/";
          return;
        }
        setOpenErrorAlert(true);
        setLoading(false);
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setLoading(false);
      });
  };

  const onChangePasswordHandler = (e) => {
    e.preventDefault();
    if (loading) return;
    if (newPassword.length < 6) {
      setChangeError("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    if (newPassword !== newRePassword) {
      setChangeError("Les mots de passe ne sont pas identiques.");
      return;
    }
    if (newPassword === userPassword) {
      setChangeError("Le nouveau mot de passe doit être différent de l’ancien.");
      return;
    }
    setLoading(true);
    setChangeError("");
    AuthentificationService.changeForcedPassword(
      userName.trim(),
      userPassword,
      newPassword
    )
      .then((response) => {
        if (response.data.success) {
          // re-authenticate with the new password: normal login flow
          setUserPassword(newPassword);
          return AuthentificationService.login(userName.trim(), newPassword).then(
            (loginResponse) => {
              if (
                loginResponse.data["token"] &&
                !loginResponse.data["token"].mustChangePassword
              ) {
                localStorage.setItem("user", JSON.stringify(loginResponse.data));
                localStorage.setItem(
                  "status",
                  JSON.stringify(loginResponse.data.token.nameRole)
                );
                localStorage.setItem("accessIsDenied", "connected");
                window.location.href = "/";
                return;
              }
              setMustChange(false);
              setLoading(false);
            }
          );
        }
        setChangeError("Impossible de changer le mot de passe.");
        setLoading(false);
      })
      .catch(() => {
        setChangeError("Impossible de changer le mot de passe.");
        setLoading(false);
      });
  };

  return (
    <div style={styles.page}>
      {/* Brand panel */}
      <div style={styles.brandPanel} className="d-none d-md-flex">
        <img
          src={`${process.env.PUBLIC_URL}/noryx-logo.png`}
          alt="NORYX - L’ERP simple pour votre entreprise"
          style={{ width: "100%", maxWidth: 440 }}
        />
      </div>

      {/* Form panel */}
      <div style={styles.formPanel}>
        {mustChange ? (
          <form style={styles.card} onSubmit={onChangePasswordHandler}>
            <h2 style={{ fontWeight: 700, marginBottom: 4 }}>
              Nouveau mot de passe
            </h2>
            <p className="mb-4" style={{ color: "#9aa5ab" }}>
              Votre mot de passe a été réinitialisé par un administrateur.
              Choisissez un nouveau mot de passe pour continuer.
            </p>
            <div className="form-group">
              <label htmlFor="new-password">Nouveau mot de passe</label>
              <input
                id="new-password"
                type="password"
                className="form-control"
                style={{ ...styles.input, borderRight: undefined }}
                autoComplete="new-password"
                autoFocus
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="new-re-password">Confirmer le mot de passe</label>
              <input
                id="new-re-password"
                type="password"
                className="form-control"
                style={{ ...styles.input, borderRight: undefined }}
                autoComplete="new-password"
                required
                value={newRePassword}
                onChange={(e) => setNewRePassword(e.target.value)}
              />
            </div>
            {changeError && (
              <div className="text-danger mb-2" style={{ fontSize: 14 }}>
                {changeError}
              </div>
            )}
            <button
              type="submit"
              className="btn btn-success btn-block mt-4"
              style={styles.submit}
              disabled={loading || !newPassword || !newRePassword}
            >
              Enregistrer et se connecter
            </button>
          </form>
        ) : (
        <form style={styles.card} onSubmit={onLoginHandler}>
          <div className="d-md-none text-center mb-4">
            <img
              src={`${process.env.PUBLIC_URL}/noryx-logo.png`}
              alt="NORYX"
              style={{
                width: 180,
                background: "#fff",
                borderRadius: 12,
                padding: 12,
              }}
            />
          </div>
          <h2 style={{ fontWeight: 700, marginBottom: 4 }}>Bienvenue</h2>
          <p className="mb-4" style={{ color: "#9aa5ab" }}>
            Connectez-vous à NORYX pour démarrer votre session.
          </p>

          <div className="form-group">
            <label htmlFor="login-email">Email</label>
            <div className="input-group">
              <input
                id="login-email"
                type="email"
                className="form-control"
                style={styles.input}
                placeholder="nom@entreprise.com"
                autoComplete="username"
                autoFocus
                required
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
              <div className="input-group-append">
                <span className="input-group-text" style={styles.inputIcon}>
                  <span className="fas fa-envelope"></span>
                </span>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="login-password">Mot de passe</label>
            <div className="input-group">
              <input
                id="login-password"
                type={showPassword ? "text" : "password"}
                className="form-control"
                style={styles.input}
                placeholder="Votre mot de passe"
                autoComplete="current-password"
                required
                value={userPassword}
                onChange={(e) => setUserPassword(e.target.value)}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  style={styles.inputIcon}
                  role="button"
                  title={
                    showPassword
                      ? "Masquer le mot de passe"
                      : "Afficher le mot de passe"
                  }
                  onClick={() => setShowPassword((v) => !v)}
                >
                  <span
                    className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                  ></span>
                </span>
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-success btn-block mt-4"
            style={styles.submit}
            disabled={loading || !userName || !userPassword}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Connexion...
              </>
            ) : (
              "Connexion"
            )}
          </button>

          <p className="text-center mt-4 mb-0" style={{ fontSize: 13, color: "#9aa5ab" }}>
            © {new Date().getFullYear()} NORYX
          </p>
        </form>
        )}
      </div>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleInfoClose} severity="info">
          Votre session est expirée
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleErrorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleErrorClose} severity="error">
          L’adresse e-mail ou le mot de passe est incorrect.
        </Alert>
      </Snackbar>
    </div>
  );
};
export default Login;
